// @ts-strict-ignore
import { DOCUMENT } from '@angular/common';
import { ElementRef, Inject, Injectable } from '@angular/core';

import { LoggerService } from 'src/app/core/services/logger/logger.service';
import { Notification } from 'src/app/shared/notification/notification';
import { NotificationService } from 'src/app/shared/notification/notification.service';
import { loadExternalScript, ScriptParams } from 'src/app/utils/functions/load-external-script';

import { translate } from '../pipes/translate/translate.pipe';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoadingService {
  public constructor(
    private readonly notificationService: NotificationService,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly logger: LoggerService
  ) {}

  public async load(scriptParams: ScriptParams, target?: ElementRef<Element>): Promise<void> {
    return new Promise((resolve, reject) => {
      loadExternalScript(
        {
          ...scriptParams,
          onload: () => {
            resolve();
          },
          onerror: () => {
            reject(new Error(`Failed to load script '${scriptParams.scriptUrl}'`));
          }
        },
        target,
        this.document,
        this.logger
      );
    });
  }

  public raiseErrorNotification(translationKey: string): void {
    this.notificationService.notify({
      content: translate(translationKey),
      variant: 'error',
      dismissable: true,
      autoDismiss: true,
      lifetime: 5000,
      icon: 'alert-circle'
    } as Notification);
  }
}
